<template>
  <div class="sp_emailRecord">
    <el-dialog title="Daily Summary Detail"
               :visible="dailySummaryMsg.show"
               width="50%"
               :before-close="handleClose"
               :append-to-body='true'>
      <!-- <el-row style="background:#F5F7FA; padding:8px 20px; border-bottom:1px solid #E1E6ED">
        <el-col :span="24">
          <p class="label-content"><label class="label">Case NO：</label><span class="item">{{dailySummaryMsg.row.caseNo}}</span></p>
        </el-col>
        <el-col :span="24">
          <p class="label-content"><label class="label">Handler：</label><span class="item"
                  v-html="dailySummaryMsg.row.createdByName"></span></p>
        </el-col>
        <el-col :span="24">
          <p class="label-content"><label class="label">Date：</label><span class="item">{{ moment(dailySummaryMsg.row.createdDate).format('YYYY-MM-DD') }}</span></p>
        </el-col>
      </el-row> -->
      <div class="content">
        <div class="label-content">
          <span class="label">Case NO：</span>
          <span class="item">{{dailySummaryMsg.row.caseNo}}</span>
        </div>
        <div class="label-content">
          <span class="label">Handler：</span>
          <span class="item"
                v-html="dailySummaryMsg.row.createdByName"></span>
        </div>
        <div class="label-content">
          <span class="label">Date：</span>
          <span class="item">{{ moment(dailySummaryMsg.row.createdDate).format('YYYY-MM-DD') }}</span>
        </div>
      </div>

      <el-row style="background:#F5F7FA;padding:16px 20px;">
        <el-col :span="24">
          <p>
            <span style="word-break: break-word; width:100%; max-height:300px; overflow: auto; display: inline-block; padding:5px 0;"
                  v-html="dailySummaryMsg.row.dailyContent"></span>
          </p>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   size="medium">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "emailRecord",
  props: {
    dailySummaryMsg: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  data () {
    return {

    }
  },

  methods: {
    handleClose () {
      this.$emit('dailySummaryChildMsg', { close: false })
    }
  },

  computed: {
    moment () {
      return moment
    }
  }
}
</script>

<style scoped lang="scss">
.sp_emailRecord {
  width: 100%;
}
.content {
  padding: 8px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e1e6ed;
}
.label-content:nth-child(3) {
  margin-bottom: 0;
}
.label-content {
  display: inline-block;
  margin-bottom: 6px;
  height: 20px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .label {
    display: inline-block;
    margin-right: 4px;
    color: #77808c;
    text-align: right;
    width: 73px;
  }
  .item {
    font-size: 14px;
    color: #333940;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px !important;
}
/deep/.el-dialog__title {
  font-size: 16px;
  color: #13161a;
  line-height: 16px;
}
/deep/.el-dialog__footer {
  padding: 16px 20px !important;
}
</style>